import React from "react";
import { PopupEventList } from "./PopupEventList";
import moment from "moment";
import queryString from "qs";
import Select from "react-select";

export const Popup = ({
  date,
  active,
  events,
  userEvents,
  close,
  position,
  createItem,
  setPopupActive,
  removeItem,
  canCreateItems,
  createCalendar
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [hasError, setHasError] = React.useState(false);
  const [title, updateTitle] = React.useState("");
  const [startDate, updateStartDate] = React.useState(
    date.format("YYYY-MM-DD")
  );
  const [startTime, updateStartTime] = React.useState(
      '00:00'
  );
  const [endTime, updateEndTime] = React.useState(
      '23:59'
  );

  const [eventDel, updateEventDel] = React.useState(null);

  const [canSubmit, updateCanSubmit] = React.useState(false);
  const [endDate, updateEndDate] = React.useState(date.format("YYYY-MM-DD"));

  const [notes, updateNotes] = React.useState("");
  const [repeat, updateRepeat] = React.useState("");
  const [repeatDuration, updateRepeatDuration] = React.useState("");

  const popupRef = React.useRef();

  const notesRef = React.useRef();
  const notesTriggerRef = React.useRef();

  const repeatRef = React.useRef();
    const repeatTriggerRef = React.useRef();

    const handleRepeat = () => {
        repeatRef.current.classList.toggle('activeGrid');
    }


  const handleNotes = () => {
    notesRef.current.classList.toggle('active');
  }

  const closePopup = () => {
    updateEventDel(null);
    setIsSuccess(true);
    updateTitle("");
    updateNotes("");
    if(notesTriggerRef.current) {
      notesTriggerRef.current.checked = false;
      notesRef.current.classList.remove('active');
    }

    if(repeatTriggerRef.current){
      repeatTriggerRef.current.checked = false;
      repeatRef.current.classList.remove('activeGrid');
    }

    updateRepeat("");
    updateRepeatDuration("");
    close();
  }

  React.useEffect(() => {
    updateStartDate(date.format("YYYY-MM-DD"));
    updateEndDate(date.format("YYYY-MM-DD"));
    updateStartTime('00:00');
    updateEndTime('23:59');
  }, [date]);

  // Frontend validation
  React.useEffect(() => {
    const mStart = moment(startDate, "YYYY-MM-DD");
    const mEnd = moment(endDate, "YYYY-MM-DD");

    if (mStart.isSameOrBefore(mEnd)) {
      updateCanSubmit(true);
    } else {
      updateCanSubmit(false);
    }
  }, [startDate, endDate, title]);

  React.useMemo(() => {
    document.addEventListener("click", event => {
      if (event.target.closest(".calendar__popup, .calendar__cell")) return;
      closePopup();
    });

    document.addEventListener("keydown", event => {
      if (event.key === "Escape") {
        closePopup();
      }
    });
  }, []);

  const editItem = (event) => {
    console.log(event);
    updateTitle(event.title);
    updateNotes(event.notes);
    updateStartDate( event.start.substring(0,4) + '-' + event.start.substring(4,6) + '-' + event.start.substring(6,8) );
    updateEndDate(event.end.substring(0,4) + '-' + event.end.substring(4,6) + '-' + event.end.substring(6,8));
    updateStartTime(event.start_time);
    updateEndTime(event.end_time);

    updateEventDel(event);
    updateRepeat(event.repeat);
    updateRepeatDuration(event.repeat_duration);

    if(event.notes != "") {
      notesTriggerRef.current.checked = true;
      notesRef.current.classList.add('active');
    } else {
        notesTriggerRef.current.checked = false;
        notesRef.current.classList.remove('active');
    }

    if(event.repeat != "") {
        repeatTriggerRef.current.checked = true;
        repeatRef.current.classList.add('activeGrid');
    }

  }
  return (
    <div
      ref={popupRef}
      className="calendar__popup"
      style={{
        opacity: active ? 1 : 0,
        left: position.left,
        top: position.top,
        pointerEvents: active ? "all" : "none"
      }}
    >
      <button className="calendar__popupClose" onClick={() => closePopup()}>
        <span className="screen-reader-text">Popup sluiten</span>
      </button>
      <div className="calendar__popupBody">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27.625"
          height="31.5"
          viewBox="0 0 27.625 31.5"
        >
          <path
            d="M24.219,3.875H21.312V.727A.727.727,0,0,0,20.586,0H20.1a.727.727,0,0,0-.727.727V3.875H7.75V.727A.727.727,0,0,0,7.023,0H6.539a.727.727,0,0,0-.727.727V3.875H2.906A2.906,2.906,0,0,0,0,6.781V28.094A2.906,2.906,0,0,0,2.906,31H24.219a2.906,2.906,0,0,0,2.906-2.906V6.781A2.906,2.906,0,0,0,24.219,3.875ZM2.906,5.812H24.219a.97.97,0,0,1,.969.969V9.687H1.937V6.781A.97.97,0,0,1,2.906,5.812Zm21.312,23.25H2.906a.97.97,0,0,1-.969-.969V11.625h23.25V28.094A.97.97,0,0,1,24.219,29.062Zm-4.024-11.8-8.161,8.1a.727.727,0,0,1-1.027,0l-4.078-4.09a.727.727,0,0,1,0-1.028l.515-.513a.727.727,0,0,1,1.028,0l3.054,3.063,7.131-7.074a.727.727,0,0,1,1.028,0l.512.516a.727.727,0,0,1,0,1.028Z"
            transform="translate(0.25 0.25)"
            fill="#282c2f"
            stroke="#fff"
            strokeWidth="0.5"
          />
        </svg>
        <h4>{date.format("dddd, DD MMMM YYYY")}</h4>
        <span>Weeknummer: {date.isoWeek()}</span>
        <PopupEventList
          events={events}
          userEvents={userEvents}
          date={date}
          removeItem={removeItem}
          canCreateItems={canCreateItems}
          editItem={editItem}
        />
      </div>
      <div className="calendar__popupForm">
        {canCreateItems ? (
          <>
            <span>Item toevoegen</span>
            <form
              onSubmit={event => {
                setIsLoading(true);
                updateCanSubmit(false);
                createItem(event, { title, startDate, endDate, startTime, endTime, notes, eventDel, repeat, repeatDuration}, (res, err) => {
                  if (err) {
                    setHasError(true);
                    setTimeout(() => {
                      setHasError(false);
                    }, 4000);
                  } else {

                    updateEventDel(null);
                    setIsSuccess(true);
                    updateTitle("");
                    updateNotes("");
                    notesTriggerRef.current.checked = false;
                    notesRef.current.classList.remove('active');
                    repeatTriggerRef.current.checked = false;
                    repeatRef.current.classList.remove('active');
                    updateRepeat("");
                    updateRepeatDuration("");
                    setTimeout(() => {
                      setIsSuccess(false);
                    }, 4000);
                  }
                  updateCanSubmit(true);
                  setIsLoading(false);
                });
                /*if(eventDel != null) {
                  const body = queryString.stringify({
                    nonce: wp.nonce,
                    action: "delete_custom_calendar_item",
                    id: eventDel?.id,
                    created_by:eventDel?.created_by,
                  });

                  // Fetch yo
                  fetch(wp.ajaxUrl, {
                    method: "POST",
                    credentials: "same-origin",
                    headers: new Headers({
                      "Content-Type": "application/x-www-form-urlencoded",
                    }),
                    body: body,
                  }).then((res) => {});

                }*/
              }}
            >
              <input
                type="text"
                required
                placeholder="Voeg je eigen item toe"
                value={title}
                onChange={e => updateTitle(e.target.value)}
              />
              <input
                type="date"
                required
                value={startDate}
                onChange={e => updateStartDate(e.target.value)}
              />
              <span>t/m</span>
              <input
                type="date"
                value={endDate}
                onChange={e => updateEndDate(e.target.value)}
              />
              <input
                  type="time"
                  required
                  value={startTime}
                  onChange={e => updateStartTime(e.target.value)}
              />
              <span style={{gridRow:3}}>t/m</span>
              <input
                  type="time"
                  value={endTime}
                  onChange={e => updateEndTime(e.target.value)}
              />
              <div className="inputHolder" style={{gridRow:4}} >
                <input  type="checkbox" ref={repeatTriggerRef} id="repeatInput" onChange={handleRepeat}/><label htmlFor="repeatInput">Herhalen</label>

              </div>
              <div style={{gridRow:5}} className={"notes"} ref={repeatRef}>
                <input className={'g1'} type='number' name='repDuration' min='1' max='1000' value={repeatDuration} onChange={e => updateRepeatDuration(e.target.value)}/>
                <span className={'g2'}>X</span>
                <select className={'g3'} value={repeat} onChange={e => updateRepeat(e.target.value)}>
                    <option value="none">Geen</option>
                    <option value="daily">Dagelijks</option>
                    <option value="weekly">Wekelijks</option>
                    <option value="monthly">Maandelijks</option>
                    <option value="yearly">Jaarlijks</option>
                </select>



              </div>
              <div className="inputHolder" style={{gridRow:6}}>
                <input  type="checkbox" ref={notesTriggerRef} id="notesInput" onChange={handleNotes}/><label htmlFor="notesInput">Notities</label>

              </div>
              <textarea style={{gridRow:7}} className={"notes"} ref={notesRef} onChange={e => updateNotes(e.target.value)} value={notes}></textarea>
              <button
                  style={{gridRow:8}}
                disabled={!canSubmit}
                type="submit"
                id="create-event-btn"
                className={
                  hasError
                    ? "error"
                    : isSuccess
                    ? ""
                    : isLoading
                    ? ""
                    : ""
                }
              >
                <span className="screen-reader-text">Item toevoegen</span>
              </button>
            </form>
          </>
        ) : (
          <>

          </>
        )}
      </div>
    </div>
  );
};
